import { useTranslation } from 'react-i18next';

import { useGetTrapByTokenModalStore } from './Modals/GetTrapByTokenModal/GetTrapByTokenModalStore';

import Toggle from 'components/Common/Toggle';

interface Props {
  isAll: boolean;
  setIsAll: (isAll: boolean) => void;
}

const WarehouseHeader: React.FC<Props> = ({ isAll, setIsAll }) => {
  const { onGetTrapByTokenModalOpen } = useGetTrapByTokenModalStore();
  const { t } = useTranslation();

  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box d-sm-flex align-items-center">
          <div className="d-sm-flex align-items-center justify-content-between py-2 flex-grow-1">
            {/* <div className="fs-18 ">{t('DeviceWarehouse.DeviceWarehouseHeader.inventory')}</div> */}
            <button
              type="button"
              className="btn btn-md p-1 mx-3 btn-ghost-success"
              onClick={() => onGetTrapByTokenModalOpen()}
            >
              {t('DeviceWarehouse.DeviceWarehouseHeader.addTrapByToken')}
            </button>
          </div>

          <Toggle
            checked={isAll}
            onChange={() => setIsAll(!isAll)}
            label={t('DeviceWarehouse.DeviceWarehouseHeader.showInUseDevices')}
            size="sm"
            className="flex align-items-end flex-grow-1"
          />
          <div className="flex-grow-1" />
          {/* <div className="page-title-left">
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item text-muted">{t('DeviceWarehouse.DeviceWarehouseHeader.inventory')}</li>
            </ol>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default WarehouseHeader;
